<template>
  <div class="power">
  <modal name="power-modal"
         transition="nice-modal-fade"
         :min-width="200"
         :delay="100"
         :scrollable="true"
         :adaptive="true"
         :resizable="true"
         >
    <i class="fas fa-question-circle help-icon"></i>
    <span v-html="helper_for_power"></span>
  </modal>
  <modal name="productivity-modal"
         transition="nice-modal-fade"
         :min-width="200"
         :delay="100"
         :scrollable="true"
         :adaptive="true"
         :resizable="true"
         >
    <i class="fas fa-question-circle help-icon"></i>
    <span v-html="helper_for_productivity"></span>
  </modal>

    <div class="grid-x grid-margin-x">
      
      <div class="small-12 medium-6 cell">

        <label>
        <div class="form-label">Inclinaison&nbsp;:</div>
        <div class="input-group">
          <input v-model.number="tilt" @change="call_debounced_getPvgisData" type="number">
          <span class="input-group-label">
            Degrés
          </span>
        </div>
        <span class="help-text">Une toiture tuile est généralement inclinée entre 30° et 45°</span>
        <span class="help-text field-error" v-if="error_in_tilt">Le format attendu est un nombre (>=0, <=90).</span>
        </label>

      </div>

      <div class="small-12 medium-6 cell">

        <label>
        <div class="form-label">Orientation&nbsp;:</div>
        <div class="input-group">
          <input v-model.number="orientation" @change="call_debounced_getPvgisData" type="number">
          <span class="input-group-label">
            Degrés
          </span>
        </div>
        <span class="help-text">EST&nbsp;:&nbsp;-90°, SUD-EST&nbsp;:&nbsp;-45°, SUD&nbsp;:&nbsp;0°, SUD-OUEST&nbsp;:&nbsp;+45°, OUEST&nbsp;:&nbsp;+90°</span>
        <span class="help-text field-error" v-if="error_in_orientation">Le format attendu est un nombre (>=-90, <=90).</span>
        </label>
      </div>

      <div class="small-12 medium-6 cell">


        <label>
          <div class="form-label">
            Puissance&nbsp;:
            <button aria-label="Aide" class="modal-helper" @click="showModalPower"><i class="fas fa-question-circle"></i></button>
          </div>
        <div class="input-group">
          <input v-model.number="power" type="number">
          <span class="input-group-label">
            kWc
          </span>
        </div>
        <span v-if="lowTensionOnly" class="help-text field-error">Uniquement en basse tension</span>
        <span class="help-text field-error" v-if="error_in_power">Le format attendu est un nombre positif.</span>
        </label>

      </div>

      <div class="small-12 medium-6 cell">

        <label>
        <div class="form-label">Puissance d'abonnement en consommation&nbsp;:</div>
        <div class="input-group">
          <input v-model.number="subscription" type="number">
          <span class="input-group-label">
            kVA
          </span>
        </div>
        <span class="help-text">retrouvez la sur votre facture d'électricité (3-6-9-12… kVA)</span>
        <span class="help-text field-error" v-if="error_in_subscription">Le format attendu est un nombre positif.</span>
        </label>

      </div>


      <div class="small-12 medium-6 cell">

        <modal name="productible-modal-old"
               transition="nice-modal-fade"
               :min-width="200"
               :min-height="100"
               :delay="100"
               :scrollable="true"
               :adaptive="true"
               :resizable="true"
               >
          <i class="fas fa-question-circle help-icon"></i>
          <h2>Productible</h2>
          <p>
            La quantité d'énergie qu'une installation pourra produire (son productible)
            peut être calculée automatiquement à partir de
            la position géographique de l'installation et de ses
            caractéristiques (inclinaison et orientation par rapport au
            sud).
          </p>
          <p>
            Source des données : <a href="http://re.jrc.ec.europa.eu/pvg_tools/fr/tools.html" target="_blank">PVGIS</a>.
          </p>
        </modal>    


        <label>
        <div class="form-label">
          Productible&nbsp;:
          <button aria-label="Aide" class="modal-helper" @click="showModalProductivity"><i class="fas fa-question-circle"></i></button>
        </div>

        <div class="input-group">
          <input v-if="show_productivity_class" v-model.number="productivity" class="productivity_class1" type="number" title="La valeur de productible peut-être automatiquement calculée en fonction de la position et de l'orientation de l'installation">
          <input v-if="!show_productivity_class" v-model.number="productivity" class="productivity_class2" type="number" title="La valeur de productible peut-être automatiquement calculée en fonction de la position et de l'orientation de l'installation">
          <span class="input-group-label">
            kWh/kWc.an
          </span>
        </div>
        <span class="help-text field-error" v-if="error_in_productivity">Le format attendu est un nombre positif.</span>
        </label>
      </div>

      <div class="small-12 medium-6 cell">

        <div class="form-label"><br><strong>Production&nbsp;:
            <span title="Valeur calculée (puissance * productible)">
              {{ production }} kWh/an
            </span>
          </strong>
        </div>

      </div>
    </div>
  </div>
</template>


<script>

import Vue from 'vue';
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex'
import { mapFields } from 'vuex-map-fields'
import _ from 'lodash'
import apiClient from '@/api';


export default {
    name: 'GetPower',
    data () {
        return {
            show_productivity_class: false,
            debounced_getPvgisData: null,
            debounced_validateForm: null,
            helper_for_power: '',
            helper_for_productivity: '',
        }
    },
    mounted: function() {
        
        apiClient.genericGet('/eval-rentability/power-helpers/0/'
        ).then(
            response => {
                console.log('Got helpers for power', response);

                this.helper_for_power = response.helper_for_power;
                this.helper_for_productivity = response.helper_for_productivity;
            }
        );
    },
    computed: {
            ...mapMutations(
                [
                    'setFormPowerOk',
                ],
            ),
            ...mapFields(
                [
                    'tilt',
                    'orientation',
                    'power',
                    'productivity',
                    'subscription',
                    // from map
                    'latitude',
                    'longitude',
                    //
                    'form_power_ok',
                ]
            ),
        lowTensionOnly: function() {
            return parseInt(this.power) > 250;
        },
        production: function() {
            return parseInt(this.power * this.productivity);
        },
        error_in_tilt: function() {
            let ok = (this.validateFloat(this.tilt) && this.tilt<=90 && this.tilt>=0);
            return !ok;
        },
        error_in_orientation: function() {
            let ok = (this.validateFloat(this.orientation) && this.orientation<=90 && this.orientation>=-90);
            return !ok;
        },
        error_in_subscription: function() {
            let ok = this.validatePositiveFloat(this.subscription);
            return !ok;
        },
        error_in_power: function() {
            let ok = this.validatePositiveFloat(this.power);
            return !ok;
        },
        error_in_productivity: function() {
            let ok = this.validatePositiveFloat(this.productivity);
            return !ok;
        },
    },
    watch: {
        latitude: function () { this.call_debounced_getPvgisData(this); },
        longitude: function () { this.call_debounced_getPvgisData(this); },
    },
    created: function() {
        this.debounced_getPvgisData = _.debounce(this.getPvgisData, 1500);
    },
    methods: {
        validateForm: function() {
            let valid = !(
                this.error_in_tilt
                    || this.error_in_orientation
                    || this.error_in_subscription
                    || this.error_in_power
                    || this.error_in_productivity
            );
            this.$store.commit('setFormPowerOk', valid);
            return valid;
        },
        validateInteger: function(value) {
            let int_regex = new RegExp('^([0-9]+)$');
            let result = int_regex.test(value);
            return result;
        },
        validateFloat: function(value) {
            let float_regex = new RegExp('^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$');
            let result = float_regex.test(value);
            return result;
        },
        validatePositiveFloat: function(value) {
            let float_regex = new RegExp('^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$');
            let result = float_regex.test(value) && value>0;
            return result;
        },
        showModalProductivity: function() {
            this.$modal.show('productivity-modal')
        },
        showModalPower: function() {
            this.$modal.show('power-modal')
        },
        setProductivity: function(value) {
            if (this.productivity != value) {
                this.productivity = value;
                this.show_productivity_class = ! this.show_productivity_class;
            }
        },
        getTilt: function() {
            return this.tilt;
        },
        call_debounced_getPvgisData: function() {
            this.validateForm();
            this.validateFloat(this.tilt);
            if (this.debounced_getPvgisData != null) {
                if (
                    this.tilt != null
                        && this.orientation != null
                        && this.latitude != null
                        && this.longitude != null
                        && !this.error_in_tilt
                        && !this.error_in_orientation
                ) {
                    console.log('debounce productivity from PVGIS');
                    this.debounced_getPvgisData(this);
                }
            }
        },
        getPvgisData: function(obj) {
            apiClient.genericPost('/eval-rentability/compute-data/0/pvgis/',
                {
                    id: 0,
                    latitude: obj.latitude,
                    longitude: obj.longitude,
                    tilt: obj.tilt,
                    orientation: obj.orientation,
                }
            ).then(
                response => {
                    console.log('Got productivity from PVGIS', response);
                    obj.setProductivity(response.productivity);
                }
            ).catch(
                error => {
                    console.log('Error', error.response.data.error);
                    alert(error.response.data.error);
                } 
            );
        },
    },    
}

</script>

<style scoped>
.low_tension_only {
  color: #800;
}
.power table td:first-child {
    padding-right: 0.5rem;
}

.power input {
    width: 100%;
}

.power .production {
    font-weight: bold;
}

.productivity_class1 {
     animation: alert-animation1 1s 1;
}
.productivity_class2 {
     animation: alert-animation2 1s 1;
}


@keyframes alert-animation1
{
    0%      {background:white;}
    35%     {background:#ffe0a5;}
    65%     {background:#ffe0a5;}
    100%    {background:white;}
}
@keyframes alert-animation2
{
    0%      {background:white;}
    25%     {background:#ffe0a5;}
    75%     {background:#ffe0a5;}
    100%    {background:white;}
}
</style>



// WEBPACK FOOTER //
// src/components/power.vue